import React from "react";
import SessionsTable from "./SessionsTable";
import PromptsSheet from "./PromptsSheet";

const UserAnalytics: React.FC = () => (
  <div className="flex-1 min-h-0 flex flex-col">
    <SessionsTable />
    <PromptsSheet />
  </div>
);

export default UserAnalytics;
